// Query-keys factory for the property module. Everything here is a read, so no
// mutation invalidates these keys today — the tree exists so the future
// admin-driven refresh (or a manual refetch) has one place to target.
import type { PropertyListFilters } from '../types/propertyTypes'

export const propertyKeys = {
  all: ['property'] as const,
  lists: () => [...propertyKeys.all, 'list'] as const,
  page: (filters: PropertyListFilters, page: number) =>
    [...propertyKeys.lists(), filters, page] as const,
  statusCounts: () => [...propertyKeys.all, 'statusCounts'] as const,
  details: () => [...propertyKeys.all, 'detail'] as const,
  detail: (id: string) => [...propertyKeys.details(), id] as const,
  // Under the detail, so refreshing a property also refreshes its settlement.
  settlement: (id: string) => [...propertyKeys.detail(id), 'settlement'] as const,
  extension: (id: string) => [...propertyKeys.detail(id), 'extension'] as const,
  portfolioStatus: () => [...propertyKeys.all, 'portfolioStatus'] as const,
}
